// @flow
// external libs
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  sendLinkRequestLoaderOff: ['requestType', 'data', 'link'],
  sendLinkSuccess: ['requestLinkId'],
  setProductLinkTitle: ['title'],
  setProductLinkUrlRequest: ['data', 'productLinkData'],
  setProductLinkUrlRequestSuccess: ['url', 'requestLinkId', 'itIsDraft'],
  saveProductLinkRequest: ['data'],
  saveProductLinkRequestSuccess: ['status'],
  resetProductLinkStatus: null,
  setLinkSaveRequestSig: ['linkSaveRequestSig'],
  setDuplicatedLink: ['duplicatedLink'],
  duplicateRequestLoaderOff: ['requestType', 'data', 'pathName'],
  linkRequestWithAsyncRequestLoaderOff: ['linkData', 'quoteRequestData'],
})

export const LinkBuilderTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  requestLinkId: '',
  manualRequestLinkId: '',
  productLinkData: {},
  linkSaveRequestSig: false,
  duplicatedLink: '',
})

/* ------------- Reducers ------------- */

const sendLinkRequestLoaderOffR = (state) => state.set('linkSaveRequestSig', false)

const sendLinkSuccessR = (state, { requestLinkId }) => state.set('requestLinkId', requestLinkId)

const setProductLinkTitleR = (state, { title }) => state.setIn(['productLinkData', 'title'], title)

const setProductLinkUrlRequestSuccessR = (state, { url, requestLinkId, itIsDraft }) =>
  state.setIn(['productLinkData', 'url'], url).set(itIsDraft ? 'requestLinkId' : 'manualRequestLinkId', requestLinkId)

const saveProductLinkRequestSuccessR = (state, { status }) =>
  state.setIn(['productLinkData', 'status'], status === 'OK')

const resetProductLinkStatusR = (state) => state.deleteIn(['productLinkData', 'status'])

const setLinkSaveRequestSigR = (state, { linkSaveRequestSig }) => state.set('linkSaveRequestSig', linkSaveRequestSig)

const setDuplicatedLinkR = (state, { duplicatedLink }) => state.set('duplicatedLink', duplicatedLink)

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SEND_LINK_REQUEST_LOADER_OFF]: sendLinkRequestLoaderOffR,
  [Types.SEND_LINK_SUCCESS]: sendLinkSuccessR,
  [Types.SET_PRODUCT_LINK_TITLE]: setProductLinkTitleR,
  [Types.SET_PRODUCT_LINK_URL_REQUEST]: (state) => state,
  [Types.SET_PRODUCT_LINK_URL_REQUEST_SUCCESS]: setProductLinkUrlRequestSuccessR,
  [Types.SAVE_PRODUCT_LINK_REQUEST]: (state) => state,
  [Types.SAVE_PRODUCT_LINK_REQUEST_SUCCESS]: saveProductLinkRequestSuccessR,
  [Types.RESET_PRODUCT_LINK_STATUS]: resetProductLinkStatusR,
  [Types.SET_LINK_SAVE_REQUEST_SIG]: setLinkSaveRequestSigR,
  [Types.SET_DUPLICATED_LINK]: setDuplicatedLinkR,
  [Types.DUPLICATE_REQUEST_LOADER_OFF]: (state) => state,
  [Types.LINK_REQUEST_WITH_ASYNC_REQUEST_LOADER_OFF]: (state) => state,
})
